import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import DataTable from '../../components/tables/DataTable';
import { getCustomer } from '../../utils/queries';

export default function CustomerDetail() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [customer, setCustomer] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		getCustomer(id).then((result) => {
			if (result?.success) setCustomer(result.data);
			setLoading(false);
		});
	}, [id]);

	if (loading) {
		return <div className='py-8 pr-8 text-sm text-gray-400'>Loading...</div>;
	}

	if (!customer) {
		return (
			<div className='py-8 pr-8'>
				<p className='text-sm text-gray-500'>Customer not found.</p>
				<button type='button' className='btn-secondary mt-4' onClick={() => navigate('/customers')}>
					Back to All Customers
				</button>
			</div>
		);
	}

	const orderColumns = [
		{
			key: 'order_number',
			header: 'Order #',
			render: (value, row) => (
				<Link to={`/orders/${row.order_id}`} className='text-black font-medium hover:underline'>
					{value}
				</Link>
			),
		},
		{
			key: 'order_date',
			header: 'Date',
			render: (value) => (value ? new Date(value).toLocaleString() : ''),
		},
		{ key: 'financial_status', header: 'Status' },
		{ key: 'total_price', header: 'Total' },
		{ key: 'erp_order_number', header: 'Pace Order #' },
	];

	return (
		<div className='py-8 pr-8 max-w-3xl'>
			<button
				type='button'
				className='text-sm text-gray-500 hover:text-black mb-2'
				onClick={() => navigate('/customers')}
			>
				&larr; ERP Customers
			</button>
			<h1 className='text-2xl font-light tracking-tight mb-1'>
				{customer.firstName} {customer.lastName}
			</h1>
			<p className='text-sm text-gray-500 mb-6'>{customer.email}</p>

			<dl className='text-sm space-y-1 mb-8 max-w-md'>
				<div className='flex justify-between'><dt className='text-gray-500'>Company</dt><dd>{customer.company || '-'}</dd></div>
				<div className='flex justify-between'><dt className='text-gray-500'>Phone</dt><dd>{customer.phone || '-'}</dd></div>
				<div className='flex justify-between'><dt className='text-gray-500'>External Customer ID</dt><dd>{customer.externalCustomerId}</dd></div>
				<div className='flex justify-between'><dt className='text-gray-500'>ERP Customer Number</dt><dd>{customer.erpContactId || '-'}</dd></div>
			</dl>

			<h2 className='text-base font-medium mb-3'>Order History</h2>
			<DataTable columns={orderColumns} data={customer.orders} emptyHeading='No orders yet' />
		</div>
	);
}
